import { MapTriggerFunction } from '../types';

export const mapSceneViewCore: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    track_event_type: 'view',
    event_trigger: 'scene_view',
});

export const mapSearchCore: MapTriggerFunction = (_triggerName, payload, _dataMapper) => ({
    app_events: 'search_success',
    search_keyword: payload.payload.searchQuery,
});

export const mapFavorite: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'subscribe_to_fav',
});

export const mapSelectContent: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'select_content',
});

export const mapPlaybackStartCore: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'video_play',
    video_event: 'video_play',
});

export const mapPlayback10Core: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'media_milestone_10_video',
    video_event: 'media_milestone_10_video',
});

export const mapPlayback50Core: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'media_milestone_50_video',
    video_event: 'media_milestone_50_video',
});

export const mapPlayback90Core: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'media_milestone_90_video',
    video_event: 'media_milestone_90_video',
});

export const mapPlaybackPauseCore: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'video_pause',
});

export const mapPlaybackUnpauseCore: MapTriggerFunction = (
    _triggerName,
    _payload,
    _dataMapper
) => ({
    app_events: 'video_unpause',
});

export const mapPlayerCloseCore: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'player_x',
});

export const mapAppCloseCore: MapTriggerFunction = (_triggerName, _payload, _dataMapper) => ({
    app_events: 'player_x',
});
